/**
 * @file
 * Attaches behaviors for DynamicsParagraph.
 */

!((Drupal, $) => {

  'use strict';
  Drupal.behaviors.paragraphDynamics = {
    attach: function () {
      const $that = this; // window
      // First call
      this.watchResizeEventForBgImg();
      let debounceWatchResizeEventForBg = Drupal.debounce(function () {
        $that.watchResizeEventForBgImg();
      }, 100);
      // Listen to on resize event
      window.addEventListener('resize', debounceWatchResizeEventForBg);
    },
    /**
     * Search the for elements having mobile image to set on responsive display
     * The mobile image when provided is used to set the background image of the
     * element when we are below 640px (UIKit small breakpoint).
     * @return {void}
     */
    watchResizeEventForBgImg: function () {
      const $mediaContainer = $('.media-container');
      if ($mediaContainer.length === 0) {
        return;
      }
      const $that = this;
      let windowWidth = $(window).width();
      $mediaContainer.each(function () {
        if (windowWidth < 960) {
          const $mobileImage = $(this).data('srcmobile');
          if ($mobileImage) {
            $that.setMobileBgImage($(this), $mobileImage);
          }
        }
        else { // Set desktop image
          $that.setMobileBgImage($(this), $(this).data('srcdesktop'));
        }
      });
    },
    /**
     * Set style background image for the given element and image URI string
     *
     * @param {object} $container the media container object
     * @param {string} $mobileImage the image BG image URI
     * @return {void}
     */
    setMobileBgImage: function ($container, $mobileImage) {
      if ($mobileImage) {
        const $imgUri = Drupal.url.toAbsolute($mobileImage);
        $container.attr('style', 'background-image: url("' + $imgUri + '"');
      }
    },

  };
})(Drupal, jQuery);

